import { setCommentText } from "../../store/comments/commentSlice";
import { useAppDispatch } from "../../store/hooks/StoreHooks";

const useCommentsFacade = () => {
    const dispatch = useAppDispatch();

    const loadCaseComments = (payload: any) => {
        return dispatch({ type: "comments/getCaseComments", payload });
    };

    const loadPostComments = (payload: any) => {
        return dispatch({ type: "comments/getPostComments", payload });
    };

    const loadDeleteComments = (payload: any) => {
        return dispatch({ type: "comments/getDeleteComments", payload });
    };

    const loadChangeLog = (payload: any) => {
        return dispatch({ type: "comments/getChangeLog", payload });
    };

    const updateCommentText = (payload: string) => {
        return dispatch(setCommentText(payload));
    };

    return {
        loadCaseComments,
        loadPostComments,
        loadDeleteComments,
        updateCommentText,
        loadChangeLog,
    };
};

export default useCommentsFacade;
